import Service from '@ember/service';
import { TrackedArray } from 'tracked-built-ins';
import FlashMessageObject from '../models/flash-message-object.ts';

export type FlashMessageOptions = {
  message: string;
  type: string;
  // 0 or false means no automatic close, true means default of 10 seconds
  duration?: number | boolean;
  // if `true` then the message can't be closed
  sticky?: boolean;
  // the name of the WFlashMessagesContainer, defaults to the empty string
  name?: string;
  // callback that is called after the message is removed
  onClose?: () => void;
};

export default class FlashMessagesService extends Service {
  /** The queue of all messages, don't use this queue to add messages, use the method `add` */
  readonly queue = new TrackedArray<FlashMessageObject>();

  add(options: FlashMessageOptions): FlashMessageObject {
    const message = new FlashMessageObject(this, options);
    this.queue.push(message);
    return message;
  }
}
